'use client';
import Image from "next/image";
import { useEffect, useState } from "react";
import ask_paul_png from "@/app/assets/common/floatbutton/ask_paul.png";
import Link from "next/link";
import { useRouter } from 'next/navigation'
// import { FloatButton } from "antd";

// const { BackTop } = FloatButton;
export default function Index(props: {eventName?: string}) {
  const router = useRouter()

  const [defaultChatId, setDefaultChatId] = useState("");
  const [isEventDetail, setIsEventDetail] = useState(false);
  
  useEffect(() => {
    // @ts-ignore
    globalThis.getDefaultChatLinkCallback = getDefaultChatLinkCallback
    const defaultChatLink = globalThis?.localStorage?.getItem("defaultChatLink")
    defaultChatLink && getDefaultChatLinkCallback(defaultChatLink)
  }, [])

  const getDefaultChatLinkCallback = (defaultChatLink1: string) => {
    if(!defaultChatLink1) return;

    const defaultChatLink = defaultChatLink1
    const url = new URL(defaultChatLink)
    const queryString = url.search;
    const params = new URLSearchParams(queryString);

    const id = params.get("id") || ""
    setDefaultChatId(id)

    // event 详情页面 头部的跳转
    const togoPaulAiDom = globalThis.document.getElementById("togoPaulAi")
    if(togoPaulAiDom) {
      setIsEventDetail(true)
      togoPaulAiDom.onclick = null;
      togoPaulAiDom.onclick = () => {
        if(!id) {
          return;
        }
        globalThis.localStorage.setItem("chat_title", props.eventName || ""); 
        globalThis.localStorage.setItem("eventName", props.eventName || "");
        // globalThis.location.href = `/chat`;
        router.push('/chat')
      }
    }
  }

  return !defaultChatId ? <Image src={ask_paul_png} alt="ask_paul" width={96} height={43}
    style={{ width: "9.6rem", height: "4.3rem" }} className="askPaul" />
    :
    <Link href={ isEventDetail ? '/chat' : `/chat/${defaultChatId}/null/null`} onClick={() => { globalThis.localStorage.setItem("chat_title", isEventDetail ? props.eventName || "" : ""); globalThis.localStorage.setItem("eventName", props.eventName || ""); }}>
      <Image src={ask_paul_png} alt="ask_paul" width={96} height={43}
        style={{ width: "9.6rem", height: "4.3rem" }} className="askPaul" />

      {/* <BackTop 
      tooltip="to top" 
      className='toTopBtn rounded-md' 
      style={{ insetBlockEnd: 134, right: 32 }}
      onClick={() => {
        window.document.body.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }}
      shape="square"
      target={() => window.document.body}
      visibilityHeight={400}
      icon={<iconpark-icon name="up" icon-id="up" color='#402C22' size='2rem' class="ml-[-0.3rem]" />}
    /> */}

      {/* <FloatButton 
      shape="square"
      tooltip="customer service" 
      className='toTopBtn rounded-md customer-service' 
      style={{ insetBlockEnd: 64 }} type='primary'
      icon={<iconpark-icon name="messages" icon-id="icon-id-messages" color='#fff' size='2.4rem' class="ml-[-0.3rem] mt-4" />} 
    /> */}
    </Link>
}